import React, { useEffect, useState } from 'react'
import { Alert, Box } from '@mui/material'

import { useLicenseStatus } from './useLicenseStatus'
import type { LicenseStatus } from '@/app/services/licenseApi'

function bannerSeverity(state: LicenseStatus['state']): 'info' | 'warning' | 'error' {
  if (state === 'trial') return 'info'
  if (state === 'read_only') return 'error'
  return 'warning'
}

export const LicenseBanner: React.FC = () => {
  const { data: status } = useLicenseStatus()
  const [dismissed, setDismissed] = useState(false)

  useEffect(() => {
    setDismissed(false)
  }, [status?.state])

  if (!status || status.state === 'active' || dismissed) {
    return <Box data-testid="license-banner-idle" />
  }

  const persistent = status.state === 'read_only'

  return (
    <Alert
      severity={bannerSeverity(status.state)}
      closeText="Dismiss"
      onClose={persistent ? undefined : () => setDismissed(true)}
    >
      {status.reason}
    </Alert>
  )
}
